module.exports = __webpack_public_path__ + "img/phhp-fixture.6c5e2982.jpg";